<div *ngIf="loading" class="loading-text">
    <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
  </div>

<div *ngIf="!loading">
<app-sub-header [pageTitle]="'Cars' | translate"></app-sub-header>

<div class="padded-container">
    <dx-accordion [collapsible]="true" [multiple]="true" (onContentReady)="onContentReady($event)">
        <dxi-item title="{{ 'CarsInService' | translate }}" [expanded]="true">
            <div *ngIf="carListResponse && carListResponse.cars">
                <div *ngFor="let carItem of carListResponse.cars">
                    <div *ngIf="carItem.driverReserved && carItem.driverReserved.trim()">
                        <dx-button class="full-width-button" type="default" (onClick)="continueNextStep(carItem.id ?? 0, carItem.number, carItem.servVoucherId ?? 0)" [text]="carItem.number + ' - ' + carItem.driverReserved">
                        </dx-button>
                    </div>
                </div>
            </div>
            <div *ngIf="!carListResponse || !carListResponse.cars.length">
                <span>{{ 'NoCars' | translate }}"></span>
            </div>
        </dxi-item>
        
        <dxi-item title="{{ 'AvailableCars' | translate }}" [expanded]="true">
            <div *ngIf="carListResponse && carListResponse.cars">
                <div *ngFor="let carItem of carListResponse.cars">
                    <div *ngIf="!carItem.driverReserved || !carItem.driverReserved.trim()">
                        <dx-button class="full-width-button" type="default" (onClick)="continueNextStep(carItem.id ?? 0, carItem.description, null)" [text]="carItem.number">
                        </dx-button>
                    </div>
                </div>
            </div>
            <div *ngIf="!carListResponse || !carListResponse.cars.length">
                <span>{{ 'NoCars' | translate }}"></span>
            </div>
        </dxi-item>
    </dx-accordion>
    
    <dx-button class="full-width-button" type="danger" (onClick)="navigateToService()" text="{{ 'Back' | translate }}"></dx-button>
</div>
</div>